import WantPricePage from "./WantPrice.js";
import SaveForLaterPage from "./SaveForLater.js";

import EmailUnpricedQuotePage from "./EmailUnpricedQuote.js";
import RedirectToDGNPage from "./RedirectToDGN.js";
import PostcodeForm from "./Postcode.js";
import InstallersForm from "./Installers.js";
import ContactDetailsForm from "./ContactDetails.js";
import ThanksPage from "./Thanks.js";

export const Postcode = PostcodeForm;
export const SaveForLater = SaveForLaterPage;
export const RedirectToDGN = RedirectToDGNPage;
export const EmailUnpricedQuote = EmailUnpricedQuotePage;

export const Installers = InstallersForm;
export const ContactDetails = ContactDetailsForm;
export const Thanks = ThanksPage;
export const WantPrice = WantPricePage;



// WEBPACK FOOTER //
// ./src/containers/QuoteForm/index.js